export const DEFAULT_FABRIC_POINT_SIZE = 3;
export const DEFAULT_FABRIC_POINT_COLOR = '#4CBFD4';
export const DEFAULT_LINE_COLOR = 'rgba(64,195,253,0.9)';
export const DEFAULT_LINE_WIDTH = 3;
export const DEFAULT_FONT_SIZE = 16;
export const DEFAULT_FABRIC_FONT_COLOR = '#333';
export const DEFAULT_SHADOW = 'rgba(0,0,0,0.4) 2px 2px 4px';
